
const pageBodyItemProp = 'pageBody';
const tableOfContentsItemProp = 'tableOfContents';

const getpageBody = () => {
  return document.querySelector(`[itemprop="${pageBodyItemProp}"]`);
};

const getHeadings = () => {
  const pageBody = getpageBody();
  if (!pageBody) return null;

  return pageBody.querySelectorAll(['h2', 'h3']);
};

const existsTableOfContents = () => {
  return !!document.querySelector(`[itemprop="${tableOfContentsItemProp}"]`);
};

const generateAnchor = (id) => {
  const anchor = document.createElement('a');
  anchor.style.width = '100%';
  anchor.style.padding = 0;
  anchor.style.margin = 0;
  anchor.style.lineHeight = '21px';
  anchor.style.fontSize = '14px';
  const content = document.createTextNode(id);
  anchor.appendChild(content);
  anchor.setAttribute('href', `#${id}`);
  return anchor;
};

const generateListItem = (id, index, isNest = false) => {
  const listItem = document.createElement('li');
  /*listItem.style.padding = '8px 0';*/
  
  listItem.style.margin = 0;
  if (isNest) {
    listItem.style.padding = '5px 0 3px 20px';
    listItem.style.listStyleType = 'disc';
  }else{
    listItem.style.padding = '20px 0 3px';
  }

  
  
  const anchor = generateAnchor(id);
  listItem.appendChild(anchor);
  return listItem;
};

const generateList = (headings) => {
  if (!headings) return;

  const list = document.createElement('ul');
  list.style.padding = 0;
  list.style.margin = '1em 1.5em 0px';
  list.style.listStyle = 'disclosure-closed';
  list.style.listStylePosition = 'inside';
  
  Array.prototype.forEach.call(headings, (heading, index) => {
    const listItem = generateListItem(
      heading.id,
      index,
      heading.tagName === 'H3'
    );
    list.appendChild(listItem);
  });
  return list;
};

const generateTitle = () => {
  const title = document.createElement('h2');
	title.style.margin = '0 0.5em';
    title.style.backgroundColor = '#009499';
    title.style.padding = '10px 15px';
  
  title.style.fontSize = '1.5rem';
  title.style.fontWeight = '700';
  
  title.style.color = '#ffffff';
  title.style.lineHeight = 1.5;
  title.style.letterSpacing = '0.04em';


  const content = document.createTextNode('Index');
  title.appendChild(content);
  return title;
};

const generateTableOfContents = (headings) => {
  if (!headings) return;

  const tableOfContents = document.createElement('nav');
  tableOfContents.setAttribute('itemprop', tableOfContentsItemProp);
  tableOfContents.style.padding = '20px 5px';
  tableOfContents.style.margin = '36px 0';
  tableOfContents.style.backgroundColor = '#dae6e561';
  const title = generateTitle();
  tableOfContents.appendChild(title);
  const list = generateList(headings);
  tableOfContents.appendChild(list);
  return tableOfContents;
};

const addIdToHeading = () => {
  const headings = getHeadings();
  if (!headings) return;

  Array.prototype.forEach.call(headings, (heading) => {
    heading.id = heading.textContent;
  });
};

const addTableOfContents = () => {
  const pageBody = getpageBody();
  const headings = getHeadings();
  if (!pageBody || !headings) return;

  const tableOfContents = generateTableOfContents(headings);
  const firstHeading = headings[0];
  if (!tableOfContents || !firstHeading) return;
  if (existsTableOfContents()) return;

  pageBody.insertBefore(tableOfContents, firstHeading);
};

//リンクのズレを調整するための処理
$(function() {
  var headerHeight = 100;//固定ヘッダーの高さを入れる
  $('[href^="#"]').click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-headerHeight; 
    $("html, body").animate({scrollTop:position}, 400, "swing");//200はスクロールの移動スピードです
    return false;
  });
});

addIdToHeading();
addTableOfContents();
